"use client";

import { pushDiagnosticsEvent } from "@/lib/diagnostics/diagnostics-store";
import { errorToDiagnosticsFields, normalizeDiagnosticsEvent } from "@/lib/diagnostics/normalize";
import type { DiagnosticsEventInput } from "@/lib/diagnostics/types";

function currentRoute(): string | null {
    if (typeof window === "undefined") {
        return null;
    }
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function postDiagnosticsEvent(event: ReturnType<typeof normalizeDiagnosticsEvent>) {
    void fetch("/api/dev/diagnostics", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(event), keepalive: true }).catch(() => {
        // Dev-only sink — ignore network failures.
    });
}

export function recordDiagnosticsFromClient(input: DiagnosticsEventInput) {
    if (process.env.NODE_ENV !== "development") {
        return;
    }
    const event = normalizeDiagnosticsEvent({ ...input, route: input.route ?? currentRoute() });
    pushDiagnosticsEvent(event);
    postDiagnosticsEvent(event);
}

export function recordDiagnosticsErrorFromClient(source: DiagnosticsEventInput["source"], error: unknown, fields?: Omit<DiagnosticsEventInput, "source" | "message" | "stack" | "code">) {
    const normalized = errorToDiagnosticsFields(error);
    recordDiagnosticsFromClient({ source, message: normalized.message, stack: normalized.stack, code: normalized.code, ...fields });
}
